module.exports = __webpack_public_path__ + "static/progetto_panoramicalliving13-30e98085a8881979e2955729715e5343.jpg";